import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Toaster } from 'react-hot-toast';
import { BrowserRouter } from 'react-router-dom';

import App from './App';
import MarkerWidget from './components/integrations/MarkerWidget';
import { AuthProvider } from './contexts/AuthContext';
import { toastOptions } from './lib/toastOptions';
import './styles/globals.css';

// The react-query client is created per signed-in session by AuthProvider
// (src/lib/queryClient.ts, CASA 6.6.1).

// Dev-mode a11y auto-audit. Reports WCAG 2.1 AA violations to the console
// with a 1s debounce. Zero prod bundle impact (dynamic import + DEV gate).
if (import.meta.env.DEV) {
  import('@axe-core/react')
    .then(({ default: axe }) => axe(React, ReactDOM, 1000))
    .catch(() => {
      /* Skip if the package fails to load — dev-only convenience. */
    });
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <AuthProvider>
        <App />
        <MarkerWidget />
        <Toaster
          position="top-right"
          toastOptions={toastOptions}
        />
        {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
